import { useState } from 'react';
import { IInfinitePageResponse } from 'services/types';

export const useInfiniteHandler = () => {
  const [totalPageCount, setTotalPageCount] = useState<number>(0);

  const getNextPageParam = <T>(
    lastPage: T[],
    allPages: T[][],
    lastPageParam: unknown
  ) => {
    const latestPage = lastPageParam as number;
    const maxPage = totalPageCount - 1;
    return latestPage < maxPage ? allPages.length : undefined;
  };

  const infiniteHandler = <T>(data: IInfinitePageResponse<T>) => {
    setTotalPageCount(data.totalPageCount);

    return data.items;
  };

  return { getNextPageParam, setTotalPageCount, infiniteHandler };
};
